import { Component, NgModule , OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef, OnChanges, TemplateRef, ViewChild} from '@angular/core';
import {DemoService} from '../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';
import { MysqlService } from './../../../services/mysql.service';


import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpRequest, HttpResponse, HttpEvent } from '@angular/common/http';

// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {Observable, Subject} from 'rxjs';

import { Subscription } from 'rxjs';




import { FileUploaderService } from './../../../services/file-uploader-service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';


import { enableRipple } from '@syncfusion/ej2-base';
// enable ripple effects
enableRipple(true);
import { DataManager, ODataAdaptor, WebApiAdaptor, UrlAdaptor,Query, ReturnOption  } from '@syncfusion/ej2-data';
import { MenuItemModel } from '@syncfusion/ej2-angular-navigations';
import { PageSettingsModel, FilterSettingsModel, RowDataBoundEventArgs } from '@syncfusion/ej2-grids';
import { ChangeEventArgs } from '@syncfusion/ej2-inputs';
import { createElement } from '@syncfusion/ej2-base';
import {  GroupSettingsModel, IFilter, IFilterUI } from '@syncfusion/ej2-angular-grids';
import { GridComponent, ToolbarItems, ToolbarService, ExcelExportService } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';
import { GlobalFunctionsService } from './../../../services/global-functions.service';
import { DatePicker } from '@syncfusion/ej2-angular-calendars';
import { TabsetComponent } from 'ngx-bootstrap/tabs';

import { FilterService, Column, DateFilterUI } from '@syncfusion/ej2-angular-grids';
import { DateRangePicker } from '@syncfusion/ej2-calendars';
import { EditService, SortService,  SelectionSettingsModel } from '@syncfusion/ej2-angular-grids';
import { DataUtil } from '@syncfusion/ej2-data'; 
import { ButtonComponent } from '@syncfusion/ej2-angular-buttons';
import { PdfExportService, PageService, SearchSettingsModel, RowSelectEventArgs } from '@syncfusion/ej2-angular-grids';
import { JobSubject } from 'src/app/shared/models/jobSubject.model';



@Component({
  selector: 'app-agent-jobs-urgent-timeframes',
  templateUrl: './agent-jobs-urgent-timeframes.component.html',
  styleUrls: ['./agent-jobs-urgent-timeframes.component.scss']
})
export class AgentJobsUrgentTimeframesComponent implements OnInit {





// added to be included as a component as well
@Input() item_id?; // impliments on changes.
@Input() item_data?; // if data.model is sent : Observable<any[]>;
@Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
@Input() item_user_level_id? = '5'; // default to agent just in case
@Input() item_brand_type_id? = '';
@Input() show_buttons? = 'no'; // yes | no
@Input() widget_title? = '';
@Input() widget_size? = 'full'; // side | abstract | full


  job_table: any;
  result: any;
  client_name: any;
  persons: any;
  job_table2: any;
  client_name_value: any;
 responseDelay = 2000;
  clients: any;
  clientLocalRecord: any;
  job_types: any;
  subjects: any;
  agents_assigned: any;
  staffList: any;
  items: Object[];
  data_subjects2: any;
  initialPage: PageSettingsModel;

  jobTypesLocalRecord: any;
  changeObject: any;

  subjectLocalRecord: any;

  createdAt: any;
  nextDateLocalRecord: any;

  agentsAssignedLocalRecord: any;
  allocated_agents_list: any;

  public data: DataManager;
  public data_subjects: DataManager;
  public pageSettings: Object;
  public pageOptions = { pageSize: 100 }; 
  public filterOptions: FilterSettingsModel;
  public filterOptions_2022: FilterSettingsModel;
  public formatOptions: Object;
  // public filterOptions: FilterSettingsModel;
  public filter : IFilter;
  public toolbarOptions: ToolbarItems[] | object;
  @ViewChild('grid')
  public grid: GridComponent;
  public groupOptions: GroupSettingsModel;
  public templateOptionsDate: IFilterUI;
  public elem1: HTMLElement;
  public datePickerObj: DatePicker;

  job_table3: any; // filtered results of job table2 to load properly
  brands: any;
  brandsLocalRecord: any;
  brandLocalRecord: any;
  subject_agents_assigned: any;
  subjectsAssignedLocalRecord: any;
  allocated_agents_subject_list: any;
  brandAgentsList: any;
  assignedBrandList: any;
  public toolbar: ToolbarItems[] | object;

  search_results: any;
  search_results_processed: Array<{subject_id: number, email_sent: string}> = [];



  filterSettings: Object;
  public templateOptions: IFilter;
  public dateRangePicker: DateRangePicker;


// Evemt Emmitter to child Component
  eventsSubject: Subject<void> = new Subject<void>();
  search_resultsO: any;
  subject_sent: any;
  currentUserVAR: any;
  sessionUserId: any;
  sessionBrandId: any;
  brand_id: any;
  subject_id: any;
  get_latest_subject_note_id: Object;
  sessionUserUserName: any;
  sr: any;
  subjects_urgent: any;
  formatoptions: { type: string; format: string; };
  dateFormat: string;

  today = new Date();

  sessionUsername: any;
  all_router_details: string;
  subjects_urgent_table: any;
  assignedAgentsList: any;
  allRecipients: any;
  assigned_to_agents: string;
  user_levels: Object;
  brand_types: Object;
  brand_user_join_results: any[];
  brand_search: Object;
  brand_search_results: any;
  user_search: Object;
  user_search_results: any;
  users: Object;
  usersPrimary: Object;
  todaySetFormat: any;
  rule_text_OPEN: string;
  rule_email_text_OPEN: any;
  rule_text_UPDREQ: string;
  rule_email_text_UPDREQ: string;
  selectedrecords: Object[];
  rule_text_UPDSENT: string;
  rule_email_text_UPDSENT: string;
  rule_text_AOA: string;
  rule_email_text_AOA: string;

  // target the submit button to auto submit the form

  emitEventToChild() {
    this.eventsSubject = this.search_results;
    this.eventsSubject.next();

    this.search_resultsO = this.search_results;
  }

  public searchOptions: SearchSettingsModel;

  // custom search
  // search_model: SearchContact;
  search_model: JobSubject;






  constructor(
    private http: HttpClient, private _demoService: DemoService,
    private route: ActivatedRoute, public toastr: HotToastService,
     vcr: ViewContainerRef, private router: Router, 
     public HttpClient:HttpClient,
     private fileUploader: FileUploaderService,
     private _mysqlService: MysqlService,
     private modalService: BsModalService,
     public datepipe: DatePipe,  public gfunc: GlobalFunctionsService
  ) {


this.brand_id = this.sessionBrandId;

  this.toolbarOptions = ['Search'];

   // this.toolbar = [
   // { text: 'Agent Update Request', tooltipText: 'Click', prefixIcon: 'e-expand', id: 'Click' }];

  this.initialPage = { pageSize:10 };
  // FilterBar, Menu, Excel Checkbox
   this.filterOptions = {
      type: 'Menu'
   };

  // FilterBar, Menu, Excel Checkbox
  this.filterOptions_2022 = {
    type: 'Menu'
 };
  this.groupOptions = { columns: ['job_id'] }; // sets auto grouping for the grid
  // this.formatoptions = {};
   this.dateFormat = '';
   this.filter = {  };


   }

  ngOnInit(): void {

    this.getJobSubjectsUrgentTimeframeTableAgent(this.gfunc.sessionBrandId, this.gfunc.sessionBrandId)
    // this.refreshGrid()

setTimeout(() => {  
  console.log("A Simple Pause!"); 
  this.refreshGrid();
  console.log("Now Ready to load...");
}, 2000);


  }






refreshGrid(){ // refresh the databutton
 // this.mapJobTableLive();
// this.getJobSubjectsUrgentTable();
// this.getJobSubjectsUrgentTableClient(this.brand_id);
this.getJobSubjectsUrgentTimeframeTableAgent(this.gfunc.sessionBrandId, this.gfunc.sessionBrandId)
  this.grid.refresh();
};



getJobSubjectsUrgentTimeframeTableAgent(brand_id, assigned_agent) {
  this._demoService.getJobSubjectsUrgentTimeframeTableAgent(brand_id, assigned_agent).subscribe(
    data => { this.subjects_urgent = data;
      let subjects_urgent_top_10 = this.subjects_urgent.slice(0, 10);
      this.subjects_urgent_table = this.subjects_urgent.slice(0, 10);
      // pass so that the dates are correct in Sync
      // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
      this.subjects_urgent = DataUtil.parse.parseJson(data); 
     // console.log("Done loadng USER");
     // console.log(this.users);


    },
    error => {
    //  console.error('Error Loading User!');
    console.log(error);
    }
  ); }


// what does this do it counts maybe?
  counter(i: number) {
    return new Array(i);
}




clearSearchGrid() {
  this.grid.searchSettings.key = '';
    // this.getJobSubjectsUrgentTableClient(this.brand_id);
}

searchGrid(name) {
  this.searchOptions = {  };
  this.grid.searchSettings.key = '';
  // const searchText: string = (document.getElementsByClassName('searchtext')[0] as any).value;
  const searchText: string = name;
  this.grid.search(searchText);

}

searchGridCol(name) {
// const searchText: string = (document.getElementsByClassName('searchtext')[0] as any).value;
// const searchText: string = name;
// this.grid.search(searchText);

// clear first
this.grid.searchSettings.key = '';
// now update the search uptions
this.searchOptions = { fields: ['note_type_name'], operator: 'contains', key: name, ignoreCase: true };
// now refresh the grid
this.grid.refresh();
}


searchGridColNextDate(name) {
  // const searchText: string = (document.getElementsByClassName('searchtext')[0] as any).value;
  // const searchText: string = name;
  // this.grid.search(searchText);
  
  // clear first
  this.grid.searchSettings.key = '';
  // now update the search uptions
  this.searchOptions = { fields: ['next_date'], operator: 'lessThan', key: name, ignoreCase: true,   };
  // now refresh the grid
  this.grid.refresh();
  }



// NOT WORKING
searchGridMasters(name) {
this.grid.searchSettings.key = '';
// now update the search uptions
this.searchOptions = { 
  fields: ['assigned_to_subjects'], operator: 'equal', key: name
 
};
// now refresh the grid
this.grid.refresh();

}



    clearSearchResults(){
      this.search_results = [];
      // this.comparitor_array_A = [];
      // this.comparitor_array_A_FULL = [];
      // this.comparitor_array_B = [];
      // this.comparitor_array_B_FULL = [];
      this.toastr.info('Clearing All Comparitor FULL arrays complete.')
    }




    sortComparer(reference: string, comparer: string) { 
      // This will be triggered for comparing each value with the reference value 
      // This can be customized to compare the values as per your need and return the corresponding result 
    
      let r: number = +reference
      let c: number = +comparer
      
      if (r < c) { 
        // console.log('reference ' + reference)  
        // console.log('comparer ' + comparer)  
        return -1; 
          
      } 
      if (r > c) { 
        // console.log('reference gtr ' + reference)  
        // console.log('comparer grt' + comparer)  
          return 1; 
      } 
      //was 0
      return 0; 
    } 



 toolbarClick(args: ClickEventArgs): void {
  if (args.item.id === 'Grid_excelexport') { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
      this.grid.excelExport();
  }
}
rowDataBound(args: RowDataBoundEventArgs) {
  const job_status = 'job_status';
  if (args.data[job_status] === 'CLOSED') {
      args.row.className = 'strikethrough';
  }
}





  // https://ej2.syncfusion.com/angular/documentation/grid/tool-bar/#built-in-and-custom-items-in-toolbar
  clickHandler(args: ClickEventArgs): void {
    if (args.item.id === 'Click') {

    //  this.grid.showSpinner();

    //    alert('This function will trigger the action to Emails, and Status Notifications to Agents');
   //  console.log(args.data.items);
   


    let pdfdata;
    const query = this.grid.renderModule.data.generateQuery(); // get grid corresponding query
    for (let i = 0; i < query.queries.length; i++) {
      if (query.queries[i].fn === 'onPage') {
        query.queries.splice(i, 1);       // remove page query to get all records
        break;
      }
    }
    const fdata = new DataManager({ json: this.subjects_urgent }).executeQuery(query).then((e: any) => {
      pdfdata = e.result as object[];  // get all filtered records
      const exportProperties = {
        dataSource: pdfdata,
      };
      //console.log(pdfdata.results);
      
     // this.search_results = pdfdata.records; // need this if a grouping is set.
      this.search_results = pdfdata;
      this.toastr.info( this.search_results.length + ' subjects added to the update Request Que'); 
      this.toastr.success( "Press Start To Process Que"); 
     // this.grid.pdfExport(exportProperties);
    }).catch((e) => true);
    }

   //  this.grid.hideSpinner();

}


}
